export const API_BASE_URL = "https://hrmsapi.s3jaipur.com/api"/* || 'http://localhost:/api' */;

const apiRequest = async (url, options = {}) => {
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  const response = await fetch(`${API_BASE_URL}${url}`, {
    headers,
    ...options,
  });
  
  if (!response.ok) {
    if (response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.reload();
    }
    
    let errorMessage = 'Request failed';
    try {
      const errorData = await response.json();
      errorMessage = errorData.error || errorData.message || `HTTP ${response.status}: ${response.statusText}`;
    } catch (e) {
      errorMessage = `HTTP ${response.status}: ${response.statusText}`;
    }
    
    throw new Error(errorMessage);
  }
  
  return response.json();
};

const api = {
  auth: {
    login: (data) => apiRequest('/auth/login', { method: 'POST', body: JSON.stringify(data) }),
    register: (data) => apiRequest('/auth/register', { method: 'POST', body: JSON.stringify(data) })
  },
  users: {
    getAll: () => apiRequest('/users'),
    create: (data) => apiRequest('/users', { method: 'POST', body: JSON.stringify(data) }),
    update: (id, data) => apiRequest(`/users/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    delete: (id) => apiRequest(`/users/${id}`, { method: 'DELETE' })
  },
  workers: {
    getAll: () => apiRequest('/workers'),
    create: (data) => apiRequest('/workers', { method: 'POST', body: JSON.stringify(data) }),
    update: (id, data) => apiRequest(`/workers/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    delete: (id) => apiRequest(`/workers/${id}`, { method: 'DELETE' })
  },
  attendance: {
    getAll: () => apiRequest('/attendance'),
    create: (data) => apiRequest('/attendance', { method: 'POST', body: JSON.stringify(data) }),
    update: (id, data) => apiRequest(`/attendance/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    delete: (id) => apiRequest(`/attendance/${id}`, { method: 'DELETE' })
  },
  leaves: {
    getAll: () => apiRequest('/leaves'),
    create: (data) => apiRequest('/leaves', { method: 'POST', body: JSON.stringify(data) }),
    updateStatus: (id, status) => apiRequest(`/leaves/${id}/status`, { method: 'PUT', body: JSON.stringify({ status }) })
  },
  leaveTypes: {
    getAll: () => apiRequest('/leave-types'),
    create: (data) => apiRequest('/leave-types', { method: 'POST', body: JSON.stringify(data) }),
    update: (id, data) => apiRequest(`/leave-types/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    delete: (id) => apiRequest(`/leave-types/${id}`, { method: 'DELETE' })
  },
  holidays: {
    getAll: () => apiRequest('/holidays'),
    create: (data) => apiRequest('/holidays', { method: 'POST', body: JSON.stringify(data) }),
    update: (id, data) => apiRequest(`/holidays/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    delete: (id) => apiRequest(`/holidays/${id}`, { method: 'DELETE' })
  },
  shifts: {
    getAll: () => apiRequest('/shifts'),
    create: (data) => apiRequest('/shifts', { method: 'POST', body: JSON.stringify(data) }),
    update: (id, data) => apiRequest(`/shifts/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    delete: (id) => apiRequest(`/shifts/${id}`, { method: 'DELETE' })
  },
  payroll: {
    getAll: () => apiRequest('/payroll'),
    create: (data) => apiRequest('/payroll', { method: 'POST', body: JSON.stringify(data) }),
    update: (id, data) => apiRequest(`/payroll/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    delete: (id) => apiRequest(`/payroll/${id}`, { method: 'DELETE' }),
    getWorkerAttendance: (workerId, startDate, endDate) => {
      const params = new URLSearchParams();
      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);
      const queryString = params.toString();
      return apiRequest(`/payroll/worker-attendance/${workerId}${queryString ? '?' + queryString : ''}`);
    }
  }
};

export default api;